import tabs from "containers/Enterprise/enterpriseEarnings/tabs";
import { EarningsIcon } from "@icons";
import { permissionTypes } from "hooks/usePermissions";
import l from "@loadable/component";
import EnterpriseEarningsBreadCrumbs from "components/PlatformLayout/components/PlatformPageHeader/Breadcrumbs/EnterpriseEarningsBreadCrumbs";

const content = l(() => import("containers/Enterprise/enterpriseEarnings"));

const { ENTERPRISE_EARNINGS_VIEW } = permissionTypes;

export default {
  key: "org-earnings",
  title: EnterpriseEarningsBreadCrumbs,
  path: "/org-earnings/:tab?",
  basePath: "org-earnings",
  requiredParams: ["tab"],
  optionalParams: [],
  linkTarget: "/org-earnings",
  linkTitle: "Earnings",
  linkCategory: "Enterprise",
  icon: EarningsIcon,
  permission: [ENTERPRISE_EARNINGS_VIEW],
  content,
  sidebar: null,
  tabs,
};
